import { render, staticRenderFns } from "./ClassType.vue?vue&type=template&id=584a3179&"
import script from "./ClassType.vue?vue&type=script&lang=js&"
export * from "./ClassType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports